import React from "react";

interface DocsPageHeaderProps {
  number: string;
  title: string;
  description?: string;
}

const DocsPageHeader: React.FC<DocsPageHeaderProps> = ({ number, title, description }) => {
  return (
    <div className="mb-10">
      <div className="flex items-center gap-6 mb-6">
        <div className="flex h-11 w-11 flex-none items-center justify-center rounded-2xl bg-black text-white font-black text-xl shadow-xl shadow-black/10">
          <span className="leading-none tabular-nums">{number}</span>
        </div>
        <h1 className="not-prose text-[40px] font-black tracking-tighter text-black m-0 leading-none">
          {title}
        </h1>
      </div>
      {description && (
        <p className="text-lg text-slate-600 leading-relaxed max-w-3xl">
          {description}
        </p>
      )}
    </div>
  );
};

export default DocsPageHeader;
